// extracted by mini-css-extract-plugin
export default {"intervalTime":"src-pages-SalesChannelContentEditor-SalesChannelEditorHeader-css__intervalTime--gsK+8"};